export default __webpack_public_path__ + "static/media/stormpath.284dcbb4.svg";